import React from "react";
import {Box, Button,IconButton, Modal, Typography} from "@mui/material";
import {Close} from "@mui/icons-material";


/**
 *
 * @param root0
 * @param root0.show
 * @param root0.onClose
 */
export function PickupAlert({show, onClose}) {

  return (
    <Modal
      open={show}
      onClose={onClose}  // Reset state when modal is closed
      aria-labelledby="title-possession-modal-title"
      aria-describedby="title-possession-modal-description"
    >
      <Box
        sx={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          position: "relative"
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}  // Close and reset modal
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
          }}
        >
          <Close />
        </IconButton>

        <Typography
          id="title-possession-modal-title"
          variant="h6"
          component="h2"
          gutterBottom
        >
          Contact Us
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Typography
            id="title-possession-modal-title"
            variant="body1"
            gutterBottom
          >
            This vehicle is scheduled to be picked up by Harley-Davidson. Please direct the customer to contact Harley-Davidson Financial Services at 800-717-3450 immediately for assistance.
          </Typography>




          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}  // Reset and close modal
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
